<script>
import Layout from '@layouts/public.vue'
import * as animationData from '@assets/animations/loading.json'
import Lottie from 'vue-lottie'

export default {
  metaInfo: {
    title: 'Loading...',
    meta: [{ name: 'description', content: 'Loading page...' }],
  },
  components: {
    Layout,
    Lottie,
  },
  data() {
    return {
      defaultOptions: {
        loop: true,
        autoplay: true,
        animationData: animationData.default,
      },
      animationSpeed: 1,
    }
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim
    },
  },
}
</script>

<template>
  <Layout>
    <v-flex class="text-center">
      <Lottie
        :options="defaultOptions"
        :height="300"
        :width="300"
        @animCreated="handleAnimation"
      />

      <h2 class="white--text">Loading...</h2>
    </v-flex>
  </Layout>
</template>
